import { Button } from "@itandi/itandi-bb-ui";
import type React from "react";
import type { DealConstructionContext } from "~/models/DealConstruction";
import { isDealBillingContext } from "~/models/DealConstruction";
import { getDownloadPath } from "~/utils/api/deals/DealSettlementFile";

type Props = {
	billingTarget: "owner" | "rentee" | null;
	constructionContext: DealConstructionContext;
	dealEstimationDraftHeader: DealConstructionContext | null;
	dealEstimationHistoryContext: DealConstructionContext | null;
	handleClickBillingPreview: (() => void) | null;
	handleClickEstimationHistoryPreview: (() => void) | null;
	handleClickEstimationPreview: (() => void) | null;
	id: string;
	isSp: boolean;
	ownManagement: boolean;
	useSK: boolean;
};

export const ConstructionDownloadButtons: React.FC<Props> = ({
	id,
	constructionContext,
	dealEstimationHistoryContext,
	dealEstimationDraftHeader,
	handleClickEstimationPreview,
	handleClickEstimationHistoryPreview,
	handleClickBillingPreview,
	billingTarget,
	ownManagement,
	useSK,
	isSp
}: Props) => {
	const showSettlementInformation =
		isDealBillingContext(constructionContext) &&
		!!constructionContext.dealSettlements.length;
	const hasConstructions = !!constructionContext.dealConstructions.length;
	const hasDraftConstructions =
		!!dealEstimationDraftHeader?.dealConstructions.length;
	const hasHistoryConstructions =
		!!dealEstimationHistoryContext?.dealConstructions.length;
	const showEstimationHistory = dealEstimationHistoryContext && !ownManagement;

	const handleClickSettlementPreview = (): void => {
		const path = getDownloadPath(id, billingTarget!);
		window.open(path);
	};

	const handleClickEstimationPreviewDisabled = (() => {
		if (ownManagement && dealEstimationDraftHeader) {
			return !hasDraftConstructions && !hasConstructions;
		}
		return !hasConstructions;
	})();

	return (
		<>
			{!useSK && billingTarget !== null && (
				<Button
					disabled={!showSettlementInformation}
					onClick={handleClickSettlementPreview}
					variant="secondary"
					width={isSp ? "fill" : "default"}
				>
					精算書ダウンロード
				</Button>
			)}
			{handleClickBillingPreview && billingTarget !== null ? (
				<Button
					disabled={!hasConstructions}
					onClick={handleClickBillingPreview}
					variant="secondary"
					width={isSp ? "fill" : "default"}
				>
					請求書ダウンロード
				</Button>
			) : null}
			{handleClickEstimationPreview ? (
				<Button
					disabled={handleClickEstimationPreviewDisabled}
					onClick={handleClickEstimationPreview}
					variant="secondary"
					width={isSp ? "fill" : "default"}
				>
					{showEstimationHistory
						? "申請前見積書ダウンロード"
						: "見積書ダウンロード"}
				</Button>
			) : null}
			{handleClickEstimationHistoryPreview && !ownManagement ? (
				<Button
					disabled={!hasDraftConstructions && !hasHistoryConstructions}
					onClick={handleClickEstimationHistoryPreview}
					variant="secondary"
					width={isSp ? "fill" : "default"}
				>
					{dealEstimationHistoryContext
						? "申請後見積書ダウンロード"
						: "見積書ダウンロード"}
				</Button>
			) : null}
		</>
	);
};
